import { axiosConfig } from './axios-config.js'

// 全域設定
export const generalSetting = {
  // 取得所有設定（合併版）
  getAllSettings: (token) => axiosConfig.get('/api/general-settings', {
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  // 更新所有設定（合併版）
  updateAllSettings: (data, token) => axiosConfig.put('/api/general-settings', data, {
    headers: { Authorization: `Bearer ${token}` }
  })
}